const status = {
  ok: 'ok',
  error: 'error',
  loading: 'loading',
  feedback: 'feedback',
}

const statusCodes = {
  OK: 200,
  UNPROCESSABLE_ENTITY: 422,
  UNSUPPORTED_MEDIA_TYPE: 415,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
}

export default status

export { status, statusCodes }
